import React, { useMemo, useCallback } from "react";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import BroadcastNavigation from "../components/BroadcastNavigation";
import TemplatesView from "../components/TemplatesView";
import BroadcastMessagesView from "../components/BroadcastMessagesView";

const sectionFromPath = (pathname) => {
  if (pathname.startsWith("/broadcast/messages")) {
    return "broadcast-messages";
  }
  return "templates";
};

const BroadcastView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeSection = useMemo(() => sectionFromPath(location.pathname), [location.pathname]);

  const handleSectionChange = useCallback((sectionId) => {
    if (sectionId === "templates") navigate("/broadcast/templates");
    else if (sectionId === "broadcast-messages") navigate("/broadcast/messages");
  }, [navigate]);

  const renderDetailView = () => {
    switch (activeSection) {
      case "templates":
        return <TemplatesView />;
      case "broadcast-messages":
        return <BroadcastMessagesView />;
      default:
        return <TemplatesView />;
    }
  };

  return (
    <Box sx={{ display: "flex", height: "100%", width: "100%" }}>
      {/* Left Column: Navigation Panel (25%) */}
      {/* <Box sx={{ width: { xs: "100%", md: "20%" },
          minWidth: { xs: 0, md: 240 } }}>
        <BroadcastNavigation
          activeSection={activeSection}
          onSectionChange={handleSectionChange}
        />
      </Box> */}

      {/* Right Column: Detail View (75%) */}
      <Box sx={{ flex: 1, width: "75%" }}>{renderDetailView()}</Box>
    </Box>
  );
};

export default BroadcastView;
